export default "__VITE_ASSET__BuiQ_6d1__"